import { useParams, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Loading } from 'vnetwork-ui'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import {
    getService,
    getServiceAddonConfigoptions,
    getServiceConfigoptions,
} from '@/modules/Service/services'
import { generatePathDatacentral, paths } from '@/utils/path'
import ServiceEditForm from '../shared/ServiceEditForm'
import useQueryClientCallback from '@/hooks/useQueryClientCallback'
import SubHeaders from '@/components/Headers/SubHeaders'
import Paper from '@/components/Paper'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

const Update = () => {
    const { id: serviceID } = useParams()
    const navigate = useNavigate()
    const { t } = useTranslation()

    const { data: service, isLoading: isServiceLoading } = useQueryWithHandler({
        queryKey: [QUERY_KEYS.SERVICE_DETAIL, Number(serviceID)],
        queryFn: () => getService(Number(serviceID)),
        enabled: !!serviceID,
    })

    const { data: configoptions = [], isLoading: isConfigLoading } =
        useQueryWithHandler({
            queryKey: [QUERY_KEYS.SERVICES_CONFIGOPTIONS, Number(serviceID)],
            queryFn: () =>
                getServiceConfigoptions({ serviceID: Number(serviceID) }),
            enabled: !!serviceID,
        })
    const { data: addons = [], isLoading: isAddonsLoading } =
        useQueryWithHandler({
            queryKey: [QUERY_KEYS.SERVICES, 'addons', serviceID],
            queryFn: () =>
                getServiceAddonConfigoptions({ serviceID: Number(serviceID) }),
            enabled: !!serviceID && !!service,
        })

    const { refetch } = useQueryClientCallback({
        reactQueryKeys: [
            [QUERY_KEYS.SERVICE_DETAIL, Number(serviceID)].join('.'),
            `services.${serviceID}.actions`,
            `services.configoptions.${serviceID}`,
        ],
    })

    const handleSuccess = () => {
        refetch()
        navigate(`/services/${serviceID}`)
    }

    if (isServiceLoading || !service) {
        return (
            <div className="container mx-auto px-4 py-6 flex justify-center">
                <Loading.CircularProgress width={40} height={40} />
            </div>
        )
    }

    return (
        <>
            <SubHeaders
                breadcrumbs={[
                    {
                        path: paths.services,
                        title: t('services'),
                    },
                    {
                        path: generatePathDatacentral(paths.serviceDetail, {
                            id: service?.service_id,
                        }),
                        title: service?.service_name,
                    },
                    {
                        path: '',
                        title: t('edit-service-config'),
                    },
                ]}
            />
            <Paper>
                {isConfigLoading || isAddonsLoading ? (
                    <div className="flex justify-center py-8">
                        <Loading.CircularProgress width={30} height={30} />
                    </div>
                ) : (
                    <ServiceEditForm
                        service={service}
                        configoptions={configoptions}
                        onSuccess={handleSuccess}
                        showActions={true}
                        addons={addons}
                    />
                )}
            </Paper>
        </>
    )
}

export default Update
